module.exports = {

	themeName: "tapfiliate",

	AmChart: {
		color: "#999", backgroundColor: "#282828", fontFamily: "helvetica"
	},

	AmCoordinateChart: {
		colors: ["#305ea2", "#37d1b3", "#f0f0f0", "#305ea2", "#37d1b3", "#f0f0f0", "#305ea2", "#37d1b3", "#f0f0f0", "#305ea2", "#37d1b3", "#f0f0f0"]
	},

	AmStockChart: {
		colors: ["#639dbd", "#e8d685", "#ae85c9", "#c9f0e1", "#d48652", "#629b6d", "#719dc3", "#719dc3"]
	},

    AmSlicedChart: {
        outlineAlpha: 1,
        outlineThickness: 2,
        labelTickColor: "#FFFFFF",
        labelTickAlpha: 0.3,
        colors: ["#ddd", "#305ea2", "#37d1b3", "#ddd", "#305ea2", "#37d1b3", "#ddd","#305ea2", "#37d1b3"]
    },

	AmRectangularChart: {
		zoomOutButtonColor: '#FFFFFF',
		zoomOutButtonRollOverAlpha: 0.15,
		zoomOutButtonImage: "lensWhite.png"
	},

	AxisBase: {
		axisColor: "#f0f0f0",
		gridColor: "#aaa",
	},

/*	ChartScrollbar: {
		backgroundColor: "#000000",
		backgroundAlpha: 0.2,
		graphFillAlpha: 0.2,
		graphLineAlpha: 0,
		graphFillColor: "#FFFFFF",
		selectedGraphFillColor: "#FFFFFF",
		selectedGraphFillAlpha: 0.4,
		selectedGraphLineColor: "#FFFFFF",
		selectedBackgroundColor: "#FFFFFF",
		selectedBackgroundAlpha: 0.09,
		gridAlpha: 0.15
	},

	ChartCursor: {
		cursorColor: "#FFFFFF",
		color: "#000000",
		cursorAlpha: 0.5
	},*/

	AmLegend: {
		color: "#999"
	},

	AmGraph: {
		lineAlpha: 0.9
	},


	GaugeArrow: {
		color: "#FFFFFF",
		alpha: 0.8,
		nailAlpha: 0,
		innerRadius: "40%",
		nailRadius: 15,
		startWidth: 15,
		borderAlpha: 0.8,
		nailBorderAlpha: 0
	},

	GaugeAxis: {
		tickColor: "#FFFFFF",
		tickAlpha: 1,
		tickLength: 15,
		minorTickLength: 8,
		axisThickness: 3,
		axisColor: '#FFFFFF',
		axisAlpha: 1,
		bandAlpha: 0.8
	},

	TrendLine: {
		lineColor: "#c03246",
		lineAlpha: 0.8
	},

	// // ammap
	// AreasSettings: {
	// 	alpha: 0.8,
	// 	color: "#FFFFFF",
	// 	colorSolid: "#000000",
	// 	unlistedAreasAlpha: 0.4,
	// 	unlistedAreasColor: "#FFFFFF",
	// 	outlineColor: "#000000",
	// 	outlineAlpha: 0.5,
	// 	outlineThickness: 0.5,
	// 	rollOverColor: "#3c5bdc",
	// 	rollOverOutlineColor: "#000000",
	// 	selectedOutlineColor: "#000000",
	// 	selectedColor: "#f15135",
	// 	unlistedAreasOutlineColor: "#000000",
	// 	unlistedAreasOutlineAlpha: 0.5
	// },

	// LinesSettings: {
	// 	color: "#FFFFFF",
	// 	alpha: 0.8
	// },

	// ImagesSettings: {
	// 	alpha: 0.8,
	// 	labelColor: "#FFFFFF",
	// 	color: "#FFFFFF",
	// 	labelRollOverColor: "#3c5bdc"
	// },

	// ZoomControl: {
	// 	buttonRollOverColor: "#3c5bdc",
	// 	buttonFillColor: "#f15135",
	// 	buttonFillAlpha: 0.8,
	// 	gridBackgroundColor: "#FFFFFF",
	// 	buttonBorderAlpha:0,
	// 	buttonCornerRadius:2,
	// 	gridAlpha:0.5,
	// 	gridBackgroundColor:"#FFFFFF",
	// 	homeIconFile:"homeIconWhite.gif",
	// 	buttonIconAlpha:0.6,
	// 	gridAlpha: 0.2,
	// 	buttonSize:20
	// },

	// SmallMap: {
	// 	mapColor: "#FFFFFF",
	// 	rectangleColor: "#FFFFFF",
	// 	backgroundColor: "#000000",
	// 	backgroundAlpha: 0.7,
	// 	borderThickness: 1,
	// 	borderAlpha: 0.8
	// },

	// the defaults below are set using CSS syntax, you can use any existing css property
	// if you don't use Stock chart, you can delete lines below
	/*PeriodSelector: {
		color: "#999"
	},

	PeriodButton: {
		color: "#999",
		background: "transparent",
		opacity: 0.7,
		border: "1px solid rgba(255, 255, 255, .15)",
		MozBorderRadius: "5px",
		borderRadius: "5px",
		margin: "1px",
		outline: "none",
		boxSizing: "border-box"
	},

	PeriodButtonSelected: {
		color: "#999",
		backgroundColor: "rgba(255, 255, 255, 0.1)",
		border: "1px solid rgba(255, 255, 255, .3)",
		MozBorderRadius: "5px",
		borderRadius: "5px",
		margin: "1px",
		outline: "none",
		opacity: 1,
		boxSizing: "border-box"
	},

	PeriodInputField: {
		color: "#999",
		background: "transparent",
		border: "1px solid rgba(255, 255, 255, .15)",
		outline: "none"
	},

	DataSetSelector: {
		color: "#999",
		selectedBackgroundColor: "rgba(255, 255, 255, .25)",
		rollOverBackgroundColor: "rgba(255, 255, 255, .15)"
	},

	DataSetCompareList: {
		color: "#999",
		lineHeight: "100%",
		boxSizing: "initial",
		webkitBoxSizing: "initial",
		border: "1px solid rgba(255, 255, 255, .15)"
	},

	DataSetSelect: {
		border: "1px solid rgba(255, 255, 255, .15)",
		outline: "none"
	}*/

};
